import { I18n } from '@app/i18n/strings-keys';
import { IOrderFormFieldPath } from '@app/shared/types/entities/order/order-form.type';

const ORDER_GRID_COL_TITLES: Partial<
  Record<keyof IOrderFormFieldPath, string>
> = {
  glAccountName: I18n.Forms.GridForm.GLAccount,
  initialItemCount: I18n.Forms.GridForm.QuantityOrdered,
  quantityReceived: I18n.Forms.GridForm.QuantityReceived,
  receivedUnitCost: I18n.Forms.GridForm.ReceivedUnitCost,
  initialTotalCost: I18n.Forms.GridForm.OrderExtendedCost,
  receivedTotalCost: I18n.Forms.GridForm.ReceivedExtendedCost,
  itemName: I18n.Forms.GridForm.ItemName,
  measureEntityId: I18n.Forms.GridForm.OrderingUnit,
  initialItemCost: I18n.Forms.GridForm.UnitCost,
};

export { ORDER_GRID_COL_TITLES };
